import { snakeCase } from 'lodash';

import { MINERVA_API_URL, NEW_CLASS_BACKEND_BASE_URL } from '@/config';
import { http } from '@/plugins/http';
import types from './mutation-types';

export function fetchClasses({ dispatch }) {
  return http.get(`${MINERVA_API_URL}/classes`)
    .then(res => (
      dispatch('setClassesInStore', res.data)
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while fetching classes:', err);
      return Promise.reject(err);
    });
}

export function syncClasses({ dispatch }) {
  return http.patch(`${MINERVA_API_URL}/classes`, {})
    .then(async (res) => {
      const classList = res.data;
      const newClassListRes = await http.get(`${NEW_CLASS_BACKEND_BASE_URL}/classrooms?role=admin`);
      const newClassList = newClassListRes.data.classrooms ? newClassListRes.data.classrooms : [];
      const convertedNewClassList = [];

      newClassList.forEach((newClass) => {
        const snakeCaseNewClass = { is_new_class: true };

        Object.entries(newClass).forEach((entry) => {
          const key = snakeCase(entry[0]);
          const value = entry[1];
          snakeCaseNewClass[key] = value;
        });

        convertedNewClassList.push(snakeCaseNewClass);
      });

      return [...classList, ...convertedNewClassList];
    })
    .then(classList => (
      dispatch('setClassesInStore', classList)
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while syncing classes:', err);
      return Promise.reject(err);
    });
}

export function fetchClassStudents({ dispatch }, classId) {
  return http.get(`${MINERVA_API_URL}/classes/${classId}/students`)
    .then(res => (
      res.data
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while fetching class students:', err);
      return Promise.reject(err);
    });
}

export function fetchClassStudent({ dispatch }, { classId, studentId }) {
  return http.get(`${MINERVA_API_URL}/classes/${classId}/students/${studentId}`)
    .then(res => (
      res.data
    ))
    .catch((err) => {
      if (err.response && err.response.status === 404) {
        return null;
      }

      // TODO: handle error
      console.error('err while fetching class student:', err);
      return Promise.reject(err);
    });
}

export function syncClassStudents({ dispatch }, classId) {
  return http.patch(`${MINERVA_API_URL}/classes/${classId}/students`, {})
    .then(res => (
      res.data
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while syncing class students:', err);
      return Promise.reject(err);
    });
}

export function manageClassStudents({ dispatch }, { classId, students }) {
  return http.patch(`${MINERVA_API_URL}/classes/${classId}/student-info`, { students })
    .then(res => (
      res.data
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while managing class students:', err);
      return Promise.reject(err);
    });
}

export function fetchClassAssignments({ dispatch }, params) {
  return http.get(`${MINERVA_API_URL}/classes/${params.class_id}/assignments`, { params })
    .then(res => (
      res.data
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while fetching class assignments:', err);
      return Promise.reject(err);
    });
}

export function fetchClassTopics({ dispatch }, classId) {
  return http.get(`${MINERVA_API_URL}/classes/${classId}/topics`)
    .then(res => (
      res.data
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while fetching class topics:', err);
      return Promise.reject(err);
    });
}

export function setClassesInStore({ commit }, classList) {
  commit(types.SET_CLASSES, classList);

  return Promise.resolve(classList);
}

export function setSelectedClassId({ commit }, classId) {
  commit(types.SET_SELECTED, classId);

  return Promise.resolve();
}

export function setIsClassStudent({ commit }, isClassStudent) {
  commit(types.SET_IS_CLASS_STUDENT, isClassStudent);

  return Promise.resolve(isClassStudent);
}



// WEBPACK FOOTER //
// ./src/app/classes/store/actions.js